import React, { ReactElement, useMemo } from 'react';
import DestinationCard from '../../../../../../../components/Connectors/DestinationCard';
import { DestinationCarrousselContainer } from './styles.main';
import { useLazyLoadQuery } from 'react-relay';
import { DestinationsListQuery } from 'src/services/DOM/queries/destinationsList';
import { destinationsListQuery } from 'src/services/DOM/queries/destinationsList/__generated__/destinationsListQuery.graphql';
import { useAddConnector } from '../../../dataState';
import { buildDestinationList } from './utils/buildDestinationList';
import { buildDestinationListReturn } from './utils/buildDestinationList/model';
import { DestinationCarrousselProps } from './model.main';

/**
 * DestinationSelector component allows users to choose a destination from a list of available destinations.
 *
 * This component fetchs the DESTINATIONS list and uses the `useDestinationUIState` hook
 * to get the currently selected destination. It then renders a list of `DestinationCard` components inside a `DestinationCarroussel`.
 *
 * @component
 * @returns {JSX.Element} The rendered component.
 */

const DestinationCarroussel: React.FC<DestinationCarrousselProps> = ({
  onChooseDestination,
  chosenDestination,
  editDestination,
}): ReactElement => {
  const [addConnectorData] = useAddConnector();

  const { destinations } = useLazyLoadQuery<destinationsListQuery>(
    DestinationsListQuery,
    {
      owner: addConnectorData.domOwner,
    }
  );

  const destinationList = useMemo<buildDestinationListReturn[]>(
    () =>
      buildDestinationList({
        destinations,
        addConnectorData,
        editDestination,
        chosenDestination,
      }),
    [destinations]
  );

  return (
    <DestinationCarrousselContainer>
      {destinationList.map((destination) => (
        <DestinationCard
          key={destination.provider}
          image={destination.image}
          selected={destination.name === chosenDestination?.destinationName}
          onClick={() => onChooseDestination(destination)}
        />
      ))}
    </DestinationCarrousselContainer>
  );
};

export default DestinationCarroussel;
